import styled from 'styled-components/macro';

import {Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useWikiIndex} from "../api/wiki";
import NavLink from "./nav_link";
import {themecolors} from "../utils/themecolors";
import {ChevronRight} from "lucide-react";

const Item = styled.div`
  display: flex;
  align-items: center;
  height: 52px;
  & svg {
    margin-right: 12px;
    margin-left: auto;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : theme.placeholder_gray_2};
  }
  &:hover svg {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  }
  & span {
    cursor: pointer;
  }
`;
const Scroll = styled.div`
  max-height: 442px;
  overflow-y: auto;
`;

const WikiIndex = styled(({community, onClose}) => {
    const {feedbackCh} = useFeedback();
    const wikis = useWikiIndex(feedbackCh, community);
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Wiki</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        <Scroll>
                            {wikis?.map((wiki, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <NavLink key={index} href={`/c/${community}/wiki/${wiki.slug}`}>
                                    <Item>
                                        {wiki.page_name}
                                        <ChevronRight size={18} />
                                    </Item>
                                </NavLink>
                            ))}
                        </Scroll>

                    </Stack>
                </ModalBody>
            </ModalContent>
        </Modal>
    )})``;

export default WikiIndex;
